<template>
    <div class="mm_body">
        <mmheader :mm-site-url="mm_site_url"></mmheader>
        <section class="pad-60">	
            <div class="container">
                <div class="row max-780 text-center margin-bottom-60">
                     <div class="row">
                                <div class="col-12">
                                    <div class="successPanel">
                                        <div class="success_col_1">
                                           <p class="successHeading">
                                            Account Created
                                           </p>
                                            <p class="success-note">
                                                <i class="fa fa-check-circle-o"></i>Account successfully created
                                            </p>
                                        </div>
                                        <div class="success_col_2">
                                            <img src="@/assets/enterprise/Required_Rocket_Image_106x101.png" width="70" />
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="success_col_3">
                                           <!-- <p class="verifyEmail">Verify your email address</p> -->
                                           <div style="text-align:left;padding-left: 50px;    padding-right: 50px;">
                                           Once your account is approved, we will send a confirmation mail to activate your account.
                                           Please ensure to check your spam folder incase the email is
                                           not in your inbox.
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                         <div class="text-center button-container">
                            <button type="submit" class="btn btn-lg btn-blue text-center" @click="gotoHome">Return to homepage</button>
                         </div>
                </div>
            </div>
        </section>
        <mmfooter :mm-site-url="mm_site_url"></mmfooter>
    </div>
</template>
<style scoped>
@import 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap';
.mm_body {
    font-size: 17px !important;
    color: #939393;
    max-width: 2400px;
    margin: auto;
    font-family: "proxima-nova" , Arial, verdana !important;
}
.card-box {
    background-color: #7CC588;
    border: 1px solid #7CC588;
    color: #FFF;
    padding: 20px;
}
.card-box h3 {
    padding: 20px;
    margin: 20px;
    font-size: 18px;
    font-weight: bold;
    font-family: 'Roboto Condensed', sans-serif;
}
.pad-60 {
    padding: 60px 0px;
    min-height: 550px;
}
.max-780 {max-width: 780px; margin: auto;}
.row {
    display: block;
}
.margin-bottom-60 {margin-bottom: 60px;}
.margin-bottom-30 {margin-bottom: 30px;}
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 5px 20px 20px 20px;
    border-radius: 10px;
}
.success-msg { font-size:  1.1rem; font-weight: 900;}
.success-note i { font-size: 1.5rem; margin-right: 10px; }
.success-note { padding-left: 15px;}
.success_col_1 { width: 70%; float: left; text-align: left;}
.success_col_2 { width: 30%; float: left; padding-top: 20px;}
.success_col_3 { width: 100%; text-align: center;padding-top: 35px;}
.successHeading {    
    font-size: 20px;
    text-align: left;
    font-weight: bold;
 }
 .verifyEmail {
    font-weight: bold;
 }
 .button-container {
    margin-top: 40px;
    font-family: 'bebas-neue-pro', sans-serif;
 }
 .btn-blue {
    font-size: 18px;
    padding: 2px 30px 2px 30px;
    background-color: #00ACEE !important;
    border: 1px solid #00ACEE !important;
    border-radius: 5px; 
}  
/* media query css start */
@media (max-width: 991px) {
    .pad-60 {padding: 60px 20px;}
}
@media (min-width: 1200px){
    .container {
        width: 545px !important;
    }
}
</style>
<script>
import Vue from 'vue/dist/vue.esm';

import mmheader from './mm_header';
import mmfooter from './mm_footer';

export default {
    data() {
        return {
            mm_site_url: process.env.MM_SITE_URL,
        }
    },
    methods: {
      gotoHome() {
       window.location.href = this.mm_site_url;
      }      
    },
    components: {
        mmheader,
        mmfooter,
    },
    created() {
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/mm_create_account_success.vue